import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 5,
	viewBox: "0 -1 8 7",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4 4.77c-.08 0-.15-.01-.23-.03a.708.708 0 0 1-.35-.17L.57 1.6A.42.42 0 0 1 .43 1.25c0-.13.05-.25.15-.35A.42.42 0 0 1 .93.77c.13 0 .25.05.35.15L4 3.62l2.73-2.73c.1-.1.21-.14.35-.14s.25.05.35.15c.1.1.15.22.15.36 0 .14-.05.26-.15.35l-3 3a.71.71 0 0 1-.35.17c-.08.02-.15.03-.23.03z",
		stroke: "#1F2223",
		strokeWidth: 0
	})]
});
const ForwardRef = forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
